<template>
  <el-dialog width="800px" :visible.sync="isUpdateMajor" :show-close="false" :title="updateMajorTitle"
             :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form ref="elForm" :model="updateMajorForm"  label-width="80px" style="margin: auto;width: 520px;">
      <el-form-item label="首选科目" prop="majorType">
        <el-select v-model="updateMajorForm.major" placeholder="请选择首选科目" style="width: 260px;">
          <el-option
            v-for="item in majorList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="再选科目1" prop="subject1">
        <el-select v-model="updateMajorForm.subject1" placeholder="请选择再选科目1" style="width: 260px;">
          <el-option
            v-for="item in subjectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="再选科目2" prop="subject2">
        <el-select v-model="updateMajorForm.subject2" placeholder="请选择再选科目2" style="width: 260px;">
          <el-option
            v-for="item in subjectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      注：</br>
      1.高考年份考生在系统注册时，请真实填写高考年份、注册电话及选考科目，系统注册后，相关内容不可修改。</br>
      2.非高考年份考生，选考科目可进行修改，在考生高考年份1月1日后，系统自动提示确定选考科目，选考科目确定后，不可修改。</br>
      </br></br>
      <el-form-item>
        <el-button type="primary" @click="saveStuMajor()">立即保存</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { request } from "@/util/request.js"
import { miniThrottle } from '@/util'

export default {
  data() {
    return {
      infos: {},
      updateMajorTitle: '修改高考选科',
      majorList:[
        {
          label: '物理组',
          value: 1
        },
        {
          label: '历史组',
          value: 2
        }
      ],
      subjectList: [
        {
          label: '化学',
          value: '化学'
        },
        {
          label: '生物',
          value: '生物'
        },
        {
          label: '政治',
          value: '政治'
        },
        {
          label: '地理',
          value: '地理'
        }
      ],
      updateMajorForm: {},
      isUpdateMajor: false,
      updateScoreTitle:"",
      updateScoreForm: {},
      isUpdateScore: false,
    }
  },

  created() {
    this.infos = this.$route.params.info
    this.infos = JSON.parse(sessionStorage.getItem("user"))

    this.getUpdateMsgStatus();
  },
  mounted() {},
  methods: {
    //获取修改选科条件
    getUpdateMsgStatus(){
      if(this.infos.userType === 4){
        this.getStu();
        request({
          method: 'get',
          url: 'students/getUpdateMsgStatus',
          params: {
            stuId: this.infos.stuId
          }
        }).then(res => {
          if(res.showMajor){
            this.isUpdateMajor= true;
          }else if(res.showScore){
            this.isUpdateScore= true;
          }
        })
      }
    },
    getStu () {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.infos.userId
        }
      }).then(res => {
        this.updateMajorForm = res.data;
      })
    },
    saveStuMajor(){
      if (this.updateMajorForm.subject1 == this.updateMajorForm.subject2) {
        this.$message({
          message: '再选科目1和再选科目2不能相同！',
          type: 'error'
        });
        return;
      }
      this.updateMajorForm.disabledMajor = true;
      request({
        method: 'post',
        url: 'students/saveOrUpdateArchives',
        data: this.updateMajorForm
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
          this.isUpdateMajor = false;
        } else {
          this.$message({
            message: '操作失败~',
            type: 'error'
          });
        }
        return;
      })
    },
    saveStuScore(){
      if (this.updateScoreForm.score == '' || this.updateScoreForm.precedence == '') {
        this.$message({
          message: '请输入高考分数和位次',
          type: 'error'
        });
        return;
      }
      this.updateScoreForm.disabledScore = true;
      request({
        method: 'post',
        url: 'students/saveOrUpdateArchives',
        data: this.updateScoreForm
      }).then(res => {
        if (res.code == 0) {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
          this.isUpdateMajor = false;
        } else {
          this.$message({
            message: '操作失败~',
            type: 'error'
          });
        }
        return;
      })
    }
  }
}

</script>
